import { render, staticRenderFns } from "./ChildFormModel.vue?vue&type=template&id=59651fdb&scoped=true&"
import script from "./ChildFormModel.vue?vue&type=script&lang=js&"
export * from "./ChildFormModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59651fdb",
  null
  
)

export default component.exports